// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"errorPage_errorWrapper__1kg4N","heading":"errorPage_heading__3jx4P","content":"errorPage_content__1lh_x","buttonPosition":"errorPage_buttonPosition__3NcTa"};